<template>
  <v-card
    :height="height"
    width="700px"
    class="overflow-y-auto py-0"
    elevation="0"
  >
    <v-card-title class="py-0">
      <h4>{{ $t("kiosks.selectFiles") }} ({{ selectedCount }}):</h4>
    </v-card-title>
    <v-card-text class="py-0">
      <ul
        style="list-style-type:none;"
        class="ml-0 pl-0"
        v-if="paths.folders || paths.files"
      >
        <FileSelector
          v-model="paths.isSelected"
          label=""
          :folders="paths.folders"
          :files="paths.files"
          :fullPath="paths.fullPath"
          :isVisible="paths.isVisible"
          v-on:fileSelectionChanged="emitFileSelChanged"
        />
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
import FileSelector from './FileSelector.vue';

export default {
  components: {
    FileSelector,
  },
  model: {
    prop: 'paths',
    event: 'pathsEv',
  },
  props: {
    paths: {
      type: Object,
      default() {
        return {};
      },
    },
    height: {
      type: Number,
    },
    selectedCount: {
      type: Number,
    },
  },
  data() {
    return {
      needLogs: true,
      selectedFiles: new Set(),
    };
  },
  methods: {
    emitFileSelChanged(val, name) {
      this.$emit('fileSelectionChanged', val, name);
    },
  },
};
</script>
